import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, Input, Output, EventEmitter, forwardRef, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { prefixClass } from '../../../../core/constants/constants';

export interface Select {
    label: string;
    value: string | number;
}

@Component({
    selector: 'app-select',
    standalone: true,
    imports: [FormsModule, SelectModule, CommonModule ],
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => SelectComponent),
          multi: true
        }
      ]
})

export class SelectComponent implements ControlValueAccessor {
    @Input() options: Select[] = [];
    @Input() placeholder = '';
    @Input() disabled = false;
    @Output() selectedOptionChange = new EventEmitter<Select>();
    selectedValue: any;
    @Input()  defaultValue: any;
    // ControlValueAccessor methods
    onChange: any = () => {};
    onTouched: any = () => {};
    prefixClass: string = prefixClass;
    @Input() className: string = '';

    ngOnChanges(changes: SimpleChanges) {
      if (changes['defaultValue']) {
        this.selectedValue = this.defaultValue
      }
    }

    setDisabledState(isDisabled: boolean): void {
      this.disabled = isDisabled;
    }

    writeValue(value: any): void {
      this.selectedValue = value;
    }

    registerOnChange(fn: any): void {
      this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
      this.onTouched = fn;
    }

    setValue(value: any): void {
      this.selectedValue = value;
      this.onChange(value);
      this.selectedOptionChange.emit(value);
    }

    onOptionSelect(event: any) {
      if (event) {
        this.setValue(event.value);
      }
    }
  }
